import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import EmployeeLogin from './components/EmployeeLogin';
import EmployeeDashboard from './components/EmployeeDashboard';
import AdminDashboard from './components/AdminDashboard';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Products from './pages/Products';
import Careers from './pages/Careers';
import ContactUs from './pages/ContactUs';
import UserAgreement from './pages/UserAgreement';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataProtectionPolicy from './pages/DataProtectionPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import GDPRComplianceStatemet from './pages/GDPRComplianceStatemet';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollToTop from './components/ScrollToTop';
import ServiceSection from './pages/ServiceSection';
import ProductWedoo from './pages/ProductWedoo';
import ProductTrustmee from './pages/ProductTrustmee';
import ImportsExports from './pages/ImportsExports';
import './App.css';
import './styling/global.css';

function App() {

  useEffect(() => {
    // Disable right-click (context menu)
    const disableRightClick = (e) => {
      e.preventDefault();
      alert('Right-click has been disabled!');
    };
    document.addEventListener('contextmenu', disableRightClick);

    // Disable F12 and Ctrl+Shift+I to open dev tools
    const disableDevToolsShortcuts = (e) => {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
        alert('Inspect Element has been disabled!');
      }
    };
    document.addEventListener('keydown', disableDevToolsShortcuts);

    // Cleanup event listeners when the component unmounts
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('keydown', disableDevToolsShortcuts);
    };
  }, []);

  return (
    <Router>
      <div className="app">
        <Header />
        <ScrollToTop />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/services/section/:id" element={<ServiceSection />} />
            <Route path="/product-wedoo" element={<ProductWedoo />} />
            <Route path="/product-trustmee" element={<ProductTrustmee />} />
            <Route path="/user-agreement" element={<UserAgreement />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/data-protection-policy" element={<DataProtectionPolicy />} />
            <Route path="/cookies-policy" element={<CookiesPolicy />} />
            <Route path="/GDPR-compliance-statemet" element={<GDPRComplianceStatemet />} />
            <Route path="/login" element={<EmployeeLogin />} />
            <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/importsexports" element={<ImportsExports />} />
          </Routes>
        </main>
        <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;